import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import api from '../services/api'

export const useAuthStore = defineStore('auth', () => {
  // State
  const token = ref(localStorage.getItem('auth_token'))
  const user = ref(null)
  const loading = ref(false)
  const error = ref(null)

  // Getters
  const isAuthenticated = computed(() => !!token.value && !!user.value)

  // Actions
  const login = async (username, password) => {
    loading.value = true
    error.value = null

    try {
      // Login to get token
      const loginResponse = await api.post('/login', {
        username,
        password
      })

      const authToken = loginResponse.data.token
      token.value = authToken
      localStorage.setItem('auth_token', authToken)

      // Set token in API headers
      api.defaults.headers.common['Authorization'] = `Bearer ${authToken}`

      // Sync user to database and get profile
      await api.post('/users/sync')
      const profileResponse = await api.get('/users/profile')
      
      user.value = profileResponse.data
      
      return { success: true }
    } catch (err) {
      error.value = err.response?.data?.error || 'Login failed'
      return { success: false, error: error.value }
    } finally {
      loading.value = false
    }
  }

  const logout = () => {
    token.value = null
    user.value = null
    localStorage.removeItem('auth_token')
    delete api.defaults.headers.common['Authorization']
    error.value = null
  }

  const initializeAuth = async () => {
    if (token.value) {
      try {
        // Set token in API headers
        api.defaults.headers.common['Authorization'] = `Bearer ${token.value}`
        
        // Get user profile
        const response = await api.get('/users/profile')
        user.value = response.data
      } catch (err) {
        // Token is invalid, clear it
        logout()
      }
    }
  }

  const updateUser = (userData) => {
    user.value = { ...user.value, ...userData }
  }

  return {
    // State
    token,
    user,
    loading,
    error,
    
    // Getters
    isAuthenticated,
    
    // Actions
    login,
    logout,
    initializeAuth,
    updateUser
  }
}) 